// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.

export let DataCacheToolRayType =
{
    NoRay: 0,
    DoubleRay: 2,
    LeftRay: 3,
    RightRay: 4,
    Ray: 1
};

/// <summary>
/// 
/// </summary>
export let DataCacheToolToolType =
{
    TradingTool: 0,
    HorizontalLine: 1,
    VerticalLine: 2,
    Line: 3,
    Rectangle: 4,
    Triangle: 5,
    Polygon: 6,
    Circle: 7,
    Ellipse: 8,
    AndrewsPitchFork: 9,
    PriceChannel: 10,
    FibonacciRetracement: 11,
    FibonacciExpansion: 12,
    FibonacciArc: 13,
    FibonacciSpiral: 14,
    FibonacciEllipse: 15,
    FibonacciFans: 16,
    FibonacciPhiChannel: 17,
    FibonacciTimeGoal: 18,
    FibonacciTimeZone: 19,
    GannLine: 20,
    GannFan: 21,
    GannGrid: 22,
    InfoLine: 23,
    Symbol: 24,
    Text: 25,
    Arrow: 26,
    Uncpecified: 27,
    Label: 28,
    LineByAngle: 29,
    RegressionChanel: 30,
    ABCPatern: 31,
    PPZ: 32,
    TopBottomPattern: 33,
    ButterflyGartley: 34,
    ElliottImpulse: 35,         // Elliott Waves #105458
    ElliottCorrection: 36,
    ElliottTriangle: 37,
    ElliottTripleCombo: 38,
    ElliottDoubleCombo: 39,
};

export let SelectionModeEnum =
{
    All: 0,
    X: 1,
    Y: 2
};